module.exports = __webpack_public_path__ + "static/media/ps.9e5d947f.svg";